import React from 'react';
import { Link } from 'react-router-dom';
import { brandLogos } from '../../data/brandLogos';
import { BrandLogo } from './BrandLogo';
import { LedFrame } from '../ui/LedFrame';
export function BrandLogoStrip() {
  return <nav aria-label="Marcas disponibles" className="container-x pb-4" data-id="element-636" data-mp="dqsiogj2qs19">
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-5 lg:grid-cols-10" data-id="element-637" data-mp="8rfrxkp310te">
        {brandLogos.map((b, i) => <li key={b.slug} data-id="element-638" data-mp="16dn014klhbai" data-mpi={i}>
            <LedFrame radius={14} delay={i * 0.25} runner={false} className="bg-ink transition-transform duration-150 ease-out hover:-translate-y-0.5" data-id="element-639" data-mp="16dwp8pxtfef5">
              <Link to={`/marcas/${b.slug}`} title={`Ver 0 km ${b.name}`} className="group flex h-20 flex-col items-center justify-center gap-1.5 rounded-[14px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon sm:h-24" data-id="element-640" data-mp="wfyztz47zbky">
                <span className="opacity-80 transition-opacity duration-150 group-hover:opacity-100" data-id="element-641" data-mp="3c7d4g0apukuw">
                  <BrandLogo name={b.name} icon={b.icon} data-id="element-642" data-mp="p5q4umlc44v5" />
                </span>
                <span className="text-[10px] font-semibold tracking-wider text-mist transition-colors duration-150 group-hover:text-neon-hi" data-id="element-643" data-mp="u4b68pcboul6">{b.name.toUpperCase()}</span>
              </Link>
            </LedFrame>
          </li>)}
      </ul>
    </nav>;
}